// extracted by mini-css-extract-plugin
module.exports = {"section":"_3MNUdQ","sectionTitle":"KrtYFU","radioGroup":"_2vQnsF"};